import type { UseFormRegister, Path, FieldValues } from 'react-hook-form';

type FormInputProps<T extends FieldValues> = {
    name: Path<T>;
    label: string;
    type?: 'text' | 'email' | 'tel' | 'date' | 'datetime-local' | 'time' | 'number';
    register: UseFormRegister<T>;
    registerOptions?: Parameters<UseFormRegister<T>>[1];
    placeholder?: string;
    required?: boolean;
    min?: number;
    max?: number;
    inputMode?: 'text' | 'numeric' | 'email' | 'tel';
    showLabel?: boolean;
};

export default function FormInput<T extends FieldValues>({
    name,
    label,
    type = 'text',
    register,
    registerOptions,
    placeholder,
    required = false,
    min,
    max,
    inputMode,
    showLabel = true
}: FormInputProps<T>) {
    return (
        <div className="space-y-3">
            {showLabel && (
                <label className="block text-body-14 font-semibold text-[var(--on-surface-color)]">
                    {label} {required && '*'}
                </label>
            )}
            <input
                type={type}
                inputMode={inputMode}
                min={min}
                max={max}
                {...register(name, registerOptions)}
                className="w-full p-3 border rounded-8 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[var(--focus-ring-color)] border-[rgba(var(--on-surface-color),0.3)] bg-transparent text-[var(--on-surface-color)]"
                placeholder={placeholder}
                aria-label={!showLabel ? label : undefined}
            />
        </div>
    );
}
